// src/components/Common/Header.js
import React from "react";

const Header = () => {
  return (
    <header className="bg-[#20f] text-white py-4 text-center">
      <div className="max-w-[1200px] mx-auto">

        <h1
          className="
            text-[3.5rem] font-bold leading-[1.2]
            text-white 
            font-[Noto Sans Telugu, Baloo Tamma 2, cursive]
          "
        >
          అన్వేషణ
        </h1>

        <p
          className="
            text-[1rem] font-extralight text-[#ddd] mt-2
            font-[Noto Sans Telugu, Baloo Tamma 2, cursive]
          "
        >
          --- తెలుగు దిన పత్రిక ---
        </p>

      </div>
    </header>
  );
};

export default Header;
